import React, { useMemo, useState } from 'react';
import useSWR from 'swr';
import { Button, Center, HStack, Spinner, Stack } from '@chakra-ui/react';
import { Select } from '../../../../components/Input';
import { fetchData } from '../../../../services/fetch';
import { useFieldArray } from 'react-hook-form';
// EG-42: o MESMO card da certificação. O QuestionCardCustom não traz o rótulo
// de classificação (Pilar > Tema), e era essa a diferença visual que restava
// entre a edição do periódico e a da certificação.
import QuestionCardCertification from '../../../../components/Card/Question-card-certification';

export default function TemplateSelectEdit({
 themeIndex,
 templates,
 templatesIsLoading,
 control,
 pillarIndex,
}) {
 const {
  fields: questions,
  append: appendQuestions,
  remove: removeQuestions,
 } = useFieldArray({
  control,
  name: `form.${pillarIndex}.themes.${themeIndex}.questions`,
 });

 const [questionOptionsKey, setQuestionOptionsKey] = useState(0);
 const [selectedTemplate, setSelectedTemplate] = useState(null);
 const [isSecondSelectEnabled, setIsSecondSelectEnabled] = useState(false);
 const [tempSelectedQuestion, setTempSelectedQuestion] = useState(null);

 const { data: surveyQuestions } = useSWR(
  selectedTemplate ? `/question-template/template/${selectedTemplate}` : null,
  fetchData
 );

 const templateOptions = useMemo(
  () =>
   templates?.map((template) => ({
    label: template?.name,
    value: template?.id_survey_template,
   })) || [],
  [templates]
 );

 const selectedQuestionIds = useMemo(() => {
  return new Set(questions?.map((q) => q.id_question_template));
 }, [questions]);

 const questionOptions = useMemo(() => {
  if (!surveyQuestions?.length) {
   return [];
  }

  const options = [];
  if (selectedQuestionIds.size !== surveyQuestions.length) {
   options.push({ label: 'Todas as perguntas', value: 'all' });
  }

  const individualQuestions = surveyQuestions
   ?.filter((question) => !selectedQuestionIds.has(question.id_question_template))
   .map((question) => ({
    label: question?.questionTitleTemplate?.[0]?.description,
    value: question?.id_question_template,
   }));

  return [...options, ...individualQuestions];
 }, [surveyQuestions, selectedQuestionIds]);

 const handleTemplateSelect = (value) => {
  setSelectedTemplate(value);
  setIsSecondSelectEnabled(true);
 };

 const handleQuestionSelect = (value) => {
  setTempSelectedQuestion(value);
 };

 const addSelectedQuestion = () => {
  if (tempSelectedQuestion === 'all') {
   const allUnselectedQuestions = surveyQuestions?.filter(
    (question) => !selectedQuestionIds.has(question.id_question_template)
   );

   appendQuestions(
    allUnselectedQuestions.map((question) => ({
     ...question,
     id_question_template: question.id_question_template,
    }))
   );
  } else {
   const selectedQuestion = surveyQuestions?.find(
    (question) => question?.id_question_template === +tempSelectedQuestion
   );

   if (
    selectedQuestion &&
    !selectedQuestionIds.has(selectedQuestion.id_question_template)
   ) {
    appendQuestions({
     ...selectedQuestion,
     id_question_template: selectedQuestion.id_question_template,
    });
   }
  }

  setQuestionOptionsKey((prevKey) => prevKey + 1);
  setTempSelectedQuestion(null);
 };

 const removeQuestion = (index) => {
  removeQuestions(index);
 };

 if (templatesIsLoading) {
  return (
   <Center py='20px'>
    <Spinner />
   </Center>
  );
 }

 return (
  <>
   <HStack spacing={6} align='end'>
    <Select
     label='Template'
     placeholder='Selecione um template'
     value={selectedTemplate} // Mantém o valor do template selecionado
     options={templateOptions}
     onChange={(e) => handleTemplateSelect(e.target.value)}
    />
    <Select
     key={questionOptionsKey}
     label='Pergunta'
     placeholder='Selecione uma pergunta'
     options={questionOptions}
     isDisabled={!isSecondSelectEnabled || !surveyQuestions}
     onChange={(e) => handleQuestionSelect(e.target.value)}
    />
    <Button
     variant='primary'
     size='medium'
     w='137px'
     minW='137px'
     isDisabled={!tempSelectedQuestion || !tempSelectedQuestion.length}
     onClick={addSelectedQuestion}
    >
     Adicionar
    </Button>
   </HStack>
   {questions?.map((question, i) => (
    <QuestionCardCertification
     key={question?.id_question_template}
     index={i}
     remove={() => removeQuestion(i)}
     question={question}
    />
   ))}
  </>
 );
}
